import React from 'react';
import classnames from 'classnames';
import { bool, node } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Progress from '../progress';
import { FadeTransition, animationTimeout } from '../animation';

export const messages = defineMessages({
  loading: {
    id: 'loadingWrapper.loading',
    defaultMessage: 'Loading...',
  },
});

const LoadingFallback = ({ message }) => (
  <div className="empty-wrapper">
    {message || <FormattedMessage {...messages.loading} />}
  </div>
);

const LoadingWrapper = ({
  className,
  loading,
  message,
  displayFallback,
  children,
}) => (
  <TransitionGroup
    className={classnames(
      className,
      'loading-wrapper',
    )}
  >
    {loading && (
      <CSSTransition key="progress" classNames="progress" timeout={animationTimeout}>
        <Progress className="progress" />
      </CSSTransition>
    )}
    {loading && displayFallback && (
      <FadeTransition key="content">
        <LoadingFallback message={message} />
      </FadeTransition>
    )}
    {!loading && (
      <FadeTransition key="content">
        {children}
      </FadeTransition>
    )}
  </TransitionGroup>
);

LoadingWrapper.propTypes = {
  loading: bool,
  message: node,
  displayFallback: bool,
  children: node.isRequired,
};

LoadingWrapper.defaultProps = {
  loading: false,
  displayFallback: true,
  message: null,
};

export default LoadingWrapper;
